<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    metaInfo () {
      return {
        title: 'Noisypeak',
        titleTemplate:
          '%s | Noisypeak',
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>
